module.exports = "<ng-template #dynamicComponent ></ng-template>\n"